import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as i } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconQueries",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, l, h, _, a) {
  return d(), n("svg", {
    "aria-label": l.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--queries"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Queries",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    i("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 1.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM8 10a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H8.5A.5.5 0 0 1 8 10Z",
      "clip-rule": "evenodd"
    }, null, -1),
    i("path", {
      fill: "currentColor",
      d: "M7.953 5.636a1 1 0 0 1 1.507.863v.004c-.001.197-.13.404-.396.612l-.005.003a2.771 2.771 0 0 1-.698.386l-.06.022a.5.5 0 1 0 .319.948l.002-.001a3.21 3.21 0 0 0 .344-.141c.193-.09.452-.228.698-.418l.007-.005c.362-.28.789-.747.789-1.409v-.004a2 2 0 0 0-3.887-.662.5.5 0 1 0 .944.332 1 1 0 0 1 .436-.53Z"
    }, null, -1)
  ])], 10, u);
}
const b = /* @__PURE__ */ s(c, [["render", m]]);
export {
  b as default
};
//# sourceMappingURL=queries.js.map
